import {useSelector} from "react-redux";

import {selectIsLoggedIn} from "../app/authSlice";

export function useIsLoggedIn(): boolean {
  return useSelector(selectIsLoggedIn);
}
